import { TextStyle } from '@tiptap/extension-text-style';

export type FontSizeValue = '24px' | '16px';

/**
 * Extends TextStyle to support a `fontSize` attribute stored as an inline style.
 *
 * Usage:
 *   editor.chain().focus().setMark('textStyle', { fontSize: '24px' }).run()
 *   editor.chain().focus().setMark('textStyle', { fontSize: null }).removeEmptyTextStyle().run()
 */
export const FontSizeTextStyle = TextStyle.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      fontSize: {
        default: null,
        parseHTML: (element: HTMLElement) => element.style.fontSize || null,
        renderHTML: (attributes: Record<string, unknown>) => {
          if (!attributes['fontSize']) {
            return {};
          }
          return { style: `font-size: ${attributes['fontSize']}` };
        },
      },
    };
  },
});
